import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    quotationsList: { quotations: [], total: 0, pageSize: 0, error: null, loading: false },
    quotationList: { quotation: null, error: null, loading: false },
    newQuotation: { quotation: null, error: null, loading: false },
    updateQuotation: { quotation: null, error: null, loading: false },
    deleteQuotation: { quotation: null, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.FETCH_QUOTATIONS:
            return {
                ...state,
                quotationsList: {
                    ...state.quotationsList,
                    error: null,
                    loading: true,
                }
            }
        case actionTypes.FETCH_QUOTATIONS_SUCCESS:
            return {
                ...state,
                quotationsList: {
                    quotations: action.payload.quotations,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false,
                }
            }
        case actionTypes.FETCH_QUOTATIONS_FAILURE:
            return {
                ...state,
                quotationsList: {
                    quotations: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false,
                }
            }
        case actionTypes.RESET_QUOTATIONS:
            return { ...state, quotationsList: initialState.quotationsList }

        case actionTypes.FETCH_QUOTATION:
            return {
                ...state,
                quotationList: {
                    ...state.quotationList,
                    error: null,
                    loading: true,
                }
            }
        case actionTypes.FETCH_QUOTATION_SUCCESS:
            return {
                ...state,
                quotationList: {
                    quotation: action.payload.quotation,
                    error: null,
                    loading: false,
                }
            }
        case actionTypes.FETCH_QUOTATION_FAILURE:
            return {
                ...state,
                quotationList: {
                    quotations: null,
                    error: action.payload.error,
                    loading: false,
                }
            }
        case actionTypes.RESET_QUOTATION:
            return { ...state, quotationList: initialState.quotationList }

        case actionTypes.DELETE_QUOTATION:
            return { ...state, deleteQuotation: { quotation: null, error: null, loading: true } }

        case actionTypes.DELETE_QUOTATION_SUCCESS:
            return { ...state, deleteQuotation: { quotation: action.payload.quotation, error: null, loading: false } }

        case actionTypes.DELETE_QUOTATION_FAILURE:
            return { ...state, deleteQuotation: { quotation: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_QUOTATION:
            return { ...state, deleteQuotation: initialState.deleteQuotation }

        case actionTypes.CREATE_QUOTATION:
            return {
                ...state,
                newQuotation: {
                    quotation: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_QUOTATION_SUCCESS:
            return {
                ...state,
                newQuotation: {
                    quotation: action.payload.quotation,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_QUOTATION_FAILURE:
            return {
                ...state,
                newQuotation: {
                    quotation: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_QUOTATION:
            return { ...state, newQuotation: initialState.newQuotation }
        case actionTypes.UPDATE_QUOTATION:
            return {
                ...state,
                updateQuotation: {
                    quotation: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.UPDATE_QUOTATION_SUCCESS:
            return {
                ...state,
                updateQuotation: {
                    quotation: action.payload.quotation,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.UPDATE_QUOTATION_FAILURE:
            return {
                ...state,
                updateQuotation: {
                    quotation: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_UPDATE_QUOTATION:
            return { ...state, updateQuotation: initialState.updateQuotation }
        case LOGOUT_USER:
            return initialState;

        default:
            return state;

    }
}


// WEBPACK FOOTER //
// ./src/store/quotation/reducer.js